{
  "backToDevices": "Torna ai dispositivi",
  "connectionsTitle": "Connessioni",
  "currentStatusTitle": "Stato attuale",
  "deviceInfoTitle": "Informazioni sul dispositivo",
  "helpBody": "Il profilo dispositivo consente di gestire singoli dispositivi. È possibile modificare la configurazione di un dispositivo, visualizzare la cronologia degli aggiornamenti forniti e delle azioni eseguite e altro ancora.",
  "deviceIsNotCenterPivot": "Questa funzionalità è disponibile solo per i dispositivi configurati come pivot centrali.",
  "deviceLocationNotAvailable": "Posizione del dispositivo non disponibile",
  "deviceNotFoundWithCodaDeviceAlias": "Nessun dispositivo con alias {{codaDeviceAlias}} trovato.",
  "linkToActionHistory": "Comandi",
  "linkToConfiguration": "Configurazione",
  "linkToEventHistory": "Storia",
  "linkToLanding": "Casa",
  "linkToNotifications": "Notifiche",
  "locationTitle": "Posizione",
  "noWarnings": "Nessun avviso trovato per questo dispositivo.",
  "note": "Nota",
  "title": "Profilo del dispositivo",
  "warningsTitle": "Avvertenze"
}
